import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';
import useCountdown, { IUseCountDownProps } from './useCountdown';

interface ICountdownProps extends IUseCountDownProps {
  /**
   * css class
   */
  className?: string;
}

const Countdown: FC<PropsWithChildren<ICountdownProps>> & { useCountdown: typeof useCountdown } = ({ className, ...restProps }) => {
  const [, formattedText] = useCountdown(restProps);

  const rootClass = classNames('ink-countdown', className);

  return <View className={rootClass}>{formattedText}</View>;
};

Countdown.useCountdown = useCountdown;

export default Countdown;
